<template style="height:100%">
  <div ref="collegeStatistics" class="hcsjn" style="width:100%;height: 400px;background-color: aqua;"></div>
</template>
<script>

  export default {
    data() {
      return {

      };
    },
    components:{

    },
    methods: {

    },
    mounted() {
      var myChart = this.$echarts.init(this.$refs.collegeStatistics);
      var option = {
        title: [
          {
            text: '11111111'
          }
        ],
        polar: {
          radius: [30, '80%']
        },
        grid: { // 让图表占满容器 
          top: "0px", left: "0px", right: "0px", bottom: "0px"
        },
        angleAxis: {
          max: 4,
          startAngle: 75
        },
        radiusAxis: {
          type: 'category',
          data: ['a', 'b', 'c', 'd']
        },
        tooltip: {},
        series: {
          type: 'bar',
          data: [2, 1.2, 2.4, 3.6],
          coordinateSystem: 'polar',
          label: {
            show: true,
            position: 'middle',
            formatter: '{b}: {c}'
          }
        }
      };



      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    }
  };
</script>
<style>

</style>